<mat-toolbar color="accent">Clinical Notes</mat-toolbar>

<mat-dialog-content class="flex min-h-0 flex-1 flex-col overflow-hidden">
  <pr-clinical-notes
    [staffer]="data.staffer"
    [patient]="data.patient"
    [date]="data.date"
    [displayStafferSelector]="data.displayStafferSelector"
    [displayNoteHistory]="data.displayNoteHistory"
  />
</mat-dialog-content>

<mat-divider />
<mat-dialog-actions>
  <pt-buttons-container padding="none">
    <button mat-stroked-button mat-dialog-close cdkFocusInitial>Close</button>
  </pt-buttons-container>
</mat-dialog-actions>
